import React from "react";
import Register from "../../auth/register/Register";

const RegisterStep = () => <Register />;

export default RegisterStep;
